import { ButtonHierarchy, ButtonSize, MainButton } from "@beydesign/storybook"
import { Box } from "@mui/material"
import React, { useState } from "react"
import { useAppContext } from "../../app/Context"
import { CardScrim } from "../CallChrome/CardScrim"
import { ChatWithAgent } from "../CustomVideoConference/ChatWithAgent"
import { MediaSetupControls } from "../MediaControlsBar/MediaSetupControls"

interface JoinMeetingModalProps {
  open: boolean
  onClose: () => void
  onJoinCall: () => void
}

export const JoinMeetingModal: React.FC<JoinMeetingModalProps> = ({
  open,
  onClose,
  onJoinCall,
}) => {
  const [isJoining, setIsJoining] = useState(false)
  const context = useAppContext()

  if (!open) return null

  const handleJoinClick = async () => {
    if (isJoining) return
    setIsJoining(true)
    try {
      await onJoinCall()
    } finally {
      setIsJoining(false)
    }
  }

  return (
    <CardScrim>
      <ChatWithAgent
        agent={context.agent}
        sx={{
          top: "var(--spacing-tokens-size-in-px-spacing-spacing-xl)",
          left: "var(--spacing-tokens-size-in-px-spacing-spacing-xl)",
        }}
        onBackButtonClick={onClose}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "var(--spacing-tokens-size-in-px-spacing-spacing-4xl)",
          maxWidth: "588px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            fontFamily: "var(--app-font-family, figtree, sans-serif)",
            color: "var(--color-text-text-white)",
          }}
        >
          <Box
            sx={{
              fontSize: {
                xs: "var(--global-heading-m-semi-bold-font-size)",
                sm: "var(--global-heading-l-semi-bold-font-size)",
              },
              fontWeight: "var(--global-heading-l-semi-bold-font-weight)",
              lineHeight:
                "calc(var(--global-heading-l-semi-bold-line-height) * 1px)",
            }}
          >
            Ready to Join?
          </Box>
          <Box
            sx={{
              fontSize: {
                xs: "var(--global-text-m-medium-font-size)",
                sm: "var(--global-heading-l-medium-font-size)",
              },
              fontWeight: "var(--global-heading-l-medium-font-weight)",
              lineHeight:
                "calc(var(--global-heading-l-medium-line-height) * 1px)",
            }}
          >
            Check your audio and video settings before joining. Your audio and
            video will be processed by AI
          </Box>
        </Box>
        <MainButton
          onClick={handleJoinClick}
          hierarchy={ButtonHierarchy.Primary}
          size={ButtonSize.xl}
          text={isJoining ? "Joining..." : "Start Conversation"}
          disabled={isJoining}
          id="call-ready-start-conversation"
        />
      </Box>

      <MediaSetupControls />
    </CardScrim>
  )
}
